import React, { useState, useEffect } from 'react';
import { getActivatedTransactionById } from '../../actions/keyCodeActions';
import ReportedActivatedTransactionDetails from './components/ReportedActivatedTransactionDetails';
import ReportedActivatedTransactionSkusList from './components/ReportedActivatedTransactionSkusList';
import KeyProcessProgressBar from './components/KeyProcessProgressBar';
import ActionBar from '../layout/ActionBar';
import UploadActivated from './slideout/UploadActivated';
import { toast } from 'react-toastify';
import SlidingPane from 'react-sliding-pane';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../util/pageTitle';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { clearActivation } from '../../reducers/activationReducer';
import {
  addToGroup,
  removeFromGroup,
} from '../../middleware/signalRMiddleware';

function ReportedActivatedTransaction() {
  const dispatch = useAppDispatch();
  const activation = useAppSelector((state) => state.activation);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [, setPageTitle] = usePageTitle([
    'Reported activated transaction',
    'Keys',
  ]);
  const [transaction, setTransaction] = useState<any>();
  const [reload, setReload] = useState<any>();
  const { t } = useTranslation();
  const [uploadSlideoutOpen, setUploadSlideoutOpen] = useState(false);

  useEffect(() => {
    if (id) {
      getActivatedTransactionById(id)
        .then((d) => {
          setTransaction(d);
          setPageTitle([
            d.keyProviderName,
            'Reported activated transaction',
            'Keys',
          ]);
        })
        .catch(() => {
          navigate('/keys/reported-activated/');
          toast.error(t('Transaction not found'));
        });
    }
  }, [id, t, setPageTitle, navigate]);

  useEffect(() => {
    if (transaction?.status === 'Pending') {
      dispatch(addToGroup(`activation:${transaction.id}`));
      return () => {
        dispatch(removeFromGroup(`activation:${transaction.id}`));
      };
    }
  }, [transaction, dispatch]);

  useEffect(() => {
    if (activation?.id === id) {
      setTransaction((prevState: any) => ({
        ...prevState,
        ...activation,
      }));
      return () => {
        dispatch(clearActivation());
      };
    }
  }, [activation, dispatch, id]);

  return (
    <>
      <ActionBar
        breadcrumb={[
          { link: '/keys/reported-activated', label: t('Reported activated') },
          { label: t('Activated transaction') },
        ]}
      >
        <button
          className="btn btn-primary"
          onClick={() => setUploadSlideoutOpen(true)}
        >
          {t('Upload activated keys')}
        </button>
      </ActionBar>
      {transaction && (
        <>
          <ReportedActivatedTransactionDetails transaction={transaction} />
          {transaction.success && (
            <ReportedActivatedTransactionSkusList id={id} reload={reload} />
          )}
          <KeyProcessProgressBar transaction={transaction} />
        </>
      )}

      <SlidingPane
        isOpen={uploadSlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => setUploadSlideoutOpen(false)}
      >
        <UploadActivated
          done={() => {
            setUploadSlideoutOpen(false);
            setReload(new Date());
          }}
          cancel={() => setUploadSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  );
}

export default ReportedActivatedTransaction;
